import { Button } from '@/components/ui/button';
import { Home, Users, Receipt, LogOut, Package, Heart, Store, ClipboardCheck, BarChart3, Sparkles, FileText, DollarSign, Banknote, AlertTriangle, Brain, Activity, Landmark, Shield, FileCode2, Send, MessageSquare, RotateCcw, Scale, Heart as HeartPulse, Plug, Leaf, Trash2, FileWarning } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import Logo from '../Logo';

export default function AdminLayout({ children, user, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: '/admin/dashboard', icon: Home, label: 'Dashboard', testId: 'admin-nav-dashboard' },
    { path: '/admin/pilot-health', icon: Activity, label: 'Pilot Health', testId: 'admin-nav-pilot-health' },
    { path: '/admin/analytics', icon: BarChart3, label: 'Analytics', testId: 'admin-nav-analytics' },
    { path: '/admin/impact', icon: Leaf, label: 'Impact', testId: 'admin-nav-impact' },
    { path: '/admin/telemetry', icon: Brain, label: 'Agent Telemetry', testId: 'admin-nav-telemetry' },
    { path: '/admin/curation', icon: Sparkles, label: 'Curation', testId: 'admin-nav-curation' },
    { path: '/admin/approvals', icon: ClipboardCheck, label: 'Approvals', testId: 'admin-nav-approvals' },
    { path: '/admin/incidents', icon: AlertTriangle, label: 'Incidents', testId: 'admin-nav-incidents' },
    { path: '/admin/users', icon: Users, label: 'Users', testId: 'admin-nav-users' },
    { path: '/admin/retailers', icon: Store, label: 'Retailers', testId: 'admin-nav-retailers' },
    { path: '/admin/seed-cleanup', icon: Trash2, label: 'Seed Cleanup', testId: 'admin-nav-seed-cleanup' },
    { path: '/admin/retailer-payouts', icon: Banknote, label: 'Retailer Payouts', testId: 'admin-nav-retailer-payouts' },
    { path: '/admin/refunds', icon: RotateCcw, label: 'Refunds', testId: 'admin-nav-refunds' },
    { path: '/admin/disputes', icon: Scale, label: 'Disputes', testId: 'admin-nav-disputes' },
    { path: '/admin/reconciliation', icon: FileText, label: 'Reconciliation', testId: 'admin-nav-reconciliation' },
    { path: '/admin/tax-exceptions', icon: FileWarning, label: 'Tax Exceptions', testId: 'admin-nav-tax-exceptions' },
    { path: '/admin/drlp-api', icon: Plug, label: 'DRLP API', testId: 'admin-nav-drlp-api' },
    { path: '/admin/drlp-onboarding', icon: ClipboardCheck, label: 'DRLP Onboarding', testId: 'admin-nav-drlp-onboarding' },
    { path: '/admin/st1-automation', icon: Landmark, label: 'ST-1 Auto', testId: 'admin-nav-st1-automation' },
    { path: '/admin/system-health', icon: Activity, label: 'System Health', testId: 'admin-nav-system-health' },
    { path: '/admin/items', icon: Package, label: 'Items', testId: 'admin-nav-items' },
    { path: '/admin/transactions', icon: Receipt, label: 'Transactions', testId: 'admin-nav-transactions' },
    { path: '/admin/charities', icon: Heart, label: 'Charities', testId: 'admin-nav-charities' },
    { path: '/admin/charity-applications', icon: FileText, label: 'Applications', testId: 'admin-nav-charity-applications' },
    { path: '/admin/charity-payouts', icon: DollarSign, label: 'Charity Payouts', testId: 'admin-nav-charity-payouts' },
    { path: '/admin/tax-reports', icon: Landmark, label: 'Tax Reports', testId: 'admin-nav-tax-reports' },
    { path: '/admin/st1-preview', icon: FileCode2, label: 'ST-1 Preview', testId: 'admin-nav-st1-preview' },
    { path: '/admin/st1-filings', icon: Send, label: 'ST-1 Filings', testId: 'admin-nav-st1-filings' },
    { path: '/admin/sms-optins', icon: MessageSquare, label: 'SMS Opt-ins', testId: 'admin-nav-sms-optins' },
    { path: '/admin/ops', icon: Shield, label: 'Ops', testId: 'admin-nav-ops' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b sticky top-0 z-50 shadow-sm">
        <div className="container mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div 
              className="cursor-pointer"
              onClick={() => navigate('/admin/dashboard')}
              data-testid="admin-logo-home"
            >
              <Logo size="default" />
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-700">Admin Portal</p>
              <p className="text-xs text-gray-500">{user?.name}</p>
            </div>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={onLogout}
            data-testid="admin-logout-btn"
            className="text-gray-600 hover:text-gray-900"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Logout
          </Button>
        </div>
      </header>

      <nav className="bg-white border-b">
        <div className="container mx-auto px-4">
          <div className="flex space-x-1 overflow-x-auto">
            {(navItems || []).map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <button
                  key={item.path}
                  data-testid={item.testId}
                  onClick={() => navigate(item.path)}
                  className={`flex items-center space-x-2 px-4 py-3 border-b-2 transition-colors whitespace-nowrap ${
                    isActive
                      ? 'border-purple-600 text-purple-600'
                      : 'border-transparent text-gray-600 hover:text-gray-900'
                  }`}
                >
                  <item.icon className="w-4 h-4" />
                  <span className="text-sm font-medium">{item.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </nav>

      <main className="container mx-auto px-4 py-6">{children}</main>
    </div>
  );
}
